import { defineStore } from 'pinia'
import { omit } from 'ramda'

import { useApiClient } from '@/api'
import type { AbsenceModel, StationBoardToggleResponse } from '@/generated/api'

export const useAbsenceStore = defineStore('absence', () => {
  const apiClient = useApiClient()

  async function toggleStationBoard(enabled: boolean): Promise<StationBoardToggleResponse> {
    return apiClient.practitioners.practitionersStationboardToggleCreate({
      requestBody: { enabled },
    })
  }

  async function getAbsence(patientId?: number) {
    return apiClient.absence.absenceRetrieve({ patientId })
  }

  async function registerAbsence(payload: {
    destination: string
    return_time: string
    code?: string
    patientId?: number
  }) {
    return apiClient.absence.absenceRegisterCreate({
      requestBody: omit(['patientId'], payload) as unknown as AbsenceModel,
      patientId: payload.patientId,
    })
    //TODO: https://github.com/ferdikoomen/openapi-typescript-codegen/issues/432
  }

  async function prolongAbsence(payload: {
    id?: number
    destination?: string
    return_time?: string
    code?: string
    patientId?: number
  }) {
    return apiClient.absence.absenceProlongPartialUpdate({
      requestBody: omit(['patientId'], payload),
      patientId: payload.patientId,
    })
  }

  async function markReturned(payload: { code?: string; patientId?: number }) {
    return apiClient.absence.absenceMarkReturnedCreate({
      requestBody: { code: payload.code },
      patientId: payload.patientId,
    })
  }

  return {
    toggleStationBoard,
    getAbsence,
    registerAbsence,
    prolongAbsence,
    markReturned,
  }
})
